module.exports = __webpack_public_path__ + "img/pd-img35.95fb3adf.jpg";